export default __webpack_public_path__ + "static/media/IMG.efc1935e.png";